<template>
  <div class="pb-5" :class="[validatedSectionClass, generalClass]">
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <form @submit.prevent="validate(true)">
            <label class="control-label required" for="siteCode"
                    v-html="computeCaption(siteCodeCaption, $store.state.lang.value.toLowerCase())">
            </label>
            <div>
              <small class="text-danger" v-if="verbiage">
                {{ computeCaption(verbiage, $store.state.lang.value.toLowerCase()) }}
              </small>
            </div>
            <el-input
                  data-vv-as="Office location code"
                  id="siteCode"
                  type="text"
                  aria-required="true"
                  name="siteCode"
                  v-validate="modelValidations.siteCode"
                  v-model="model.siteCode"
                  placeholder="ex: 12345678"
                  clearable
                  onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
          <div v-if="show">
            <div
              v-for="option in options"
              @click="selectOption(option)"
              class="pt-7">
              <div :class="option.selected ? 'selected' : ''">
                <div class="bg-color p-10 rounded" >
                  <div class="row">
                    <div :class="isMobile() ? 'row' : ''">
                      <div :class="isMobile() ? 'col-xs-8 col-sm-8 float-right' : 'col-md-1 col-sm-2 col-xs-2'">
                        <div class="pt-3" :class="isMobile() ? '' : 'text-center'">
                          <p><span class="fs-17">{{ option.distance }} </span><br />
                            {{ option.distance < 2 ? 'mile' : 'miles'}}
                          </p>
                        </div>
                      </div>
                      <div :class="isMobile() ? 'col-xs-4 col-sm-4 float-left' : 'col-md-1'">
                        <div class="pt-3" :class="isMobile() ? '' : 'text-center'">
                          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve" class="map-svg" @click="openGoogleMap(option.latitude, option.longitude)">
                          <g>
                            <path class="st0" d="M20,2h-0.5L0,21.5V22c0,1.1,0.9,2,2,2h0.7L22,4.4V4C22,2.9,21.1,2,20,2z"/>
                            <path class="st1" d="M2,2C0.9,2,0,2.9,0,4v17.5L19.5,2H2z"/>
                            <polygon class="st2" points="2.7,24 19.5,24 11,15.5 	"/>
                            <polygon class="st3" points="13.5,13 22,21.5 22,4.4 	"/>
                            <path class="st4" d="M11,15.5l8.5,8.5H20c1.1,0,2-0.9,2-2v-0.5L13.5,13L11,15.5z"/>
                            <path class="st5" d="M20,2H2C0.9,2,0,2.9,0,4v0.2c0-1.1,0.9-2,2-2h18c1.1,0,2,0.9,2,2V4C22,2.9,21.1,2,20,2z"/>
                            <path class="st6" d="M20,23.8H2c-1.1,0-2-0.9-2-2V22c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2v-0.2C22,22.9,21.1,23.8,20,23.8z"/>
                            <path class="st7" d="M18,0c-3.3,0-6,2.7-6,6c0,0.2,0,0.5,0,0.7c0.2,2.1,1.3,3.9,2.6,5.7c1.2,1.8,2.4,3.7,2.9,6.2
                              c0,0.2,0.3,0.4,0.5,0.4s0.4-0.2,0.5-0.4c0.5-2.5,1.7-4.3,2.9-6.2c1.2-1.9,2.3-3.6,2.6-5.7c0-0.2,0-0.5,0-0.7C24,2.7,21.3,0,18,0z"
                              />
                            <path class="st5" d="M18,0.2c2.7,0,4.9,1.7,5.8,4.1C23.1,1.8,20.7,0,18,0s-5.1,1.8-5.8,4.3C13.1,2,15.3,0.2,18,0.2z"/>
                            <path class="st6" d="M24,6.4c-0.2,2.1-1.3,3.9-2.6,5.7c-1.2,1.8-2.4,3.7-2.9,6.2c0,0.2-0.3,0.4-0.5,0.4s-0.4-0.2-0.5-0.4
                              c-0.5-2.5-1.7-4.3-2.9-6.2c-1.2-1.9-2.3-3.6-2.6-5.7c0-0.2,0-0.4,0-0.6c0,0,0,0.1,0,0.1c0,0.2,0,0.5,0,0.7c0.2,2.1,1.3,3.9,2.6,5.7
                              c1.2,1.8,2.4,3.7,2.9,6.2c0,0.2,0.3,0.4,0.5,0.4s0.4-0.2,0.5-0.4c0.5-2.5,1.7-4.3,2.9-6.2c1.2-1.9,2.3-3.6,2.6-5.7
                              c0-0.2,0-0.5,0-0.7c0,0,0-0.1,0-0.1C24,6.1,24,6.3,24,6.4z"/>
                            <circle class="st8" cx="18" cy="6" r="2"/>
                            <circle class="st6" cx="18" cy="6" r="2"/>
                            <path class="st4" d="M5.5,10.5c-1.7,0-3-1.3-3-3s1.3-3,3-3c0.7,0,1.3,0.2,1.8,0.6L6.7,5.9C6.4,5.6,5.9,5.5,5.5,5.5
                              c-1.1,0-2,0.9-2,2s0.9,2,2,2c0.9,0,1.7-0.6,1.9-1.5H6V7h2.5v0.5C8.5,9.2,7.2,10.5,5.5,10.5z"/>

                              <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-1.3688" y1="19.508" x2="23.9359" y2="7.7082" gradientTransform="matrix(1 0 0 -1 0 26)">
                              <stop  offset="0" style="stop-color:#FFFFFF;stop-opacity:0.2"/>
                              <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0"/>
                            </linearGradient>
                            <path class="st9" d="M24,6c0-3.3-2.7-6-6-6c-1.8,0-3.4,0.8-4.5,2H2C0.9,2,0,2.9,0,4v18c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V11.5
                              c1-1.5,1.8-3,2-4.8C24,6.5,24,6.2,24,6z"/>
                          </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div :class="isMobile() ? 'col-xs-10 col-sm-10' : 'col-md-6 col-xs-6 col-sm-6'">
                      <div class=" pt-3 pb-5">
                        {{option.sitecode}}<br>{{option.address}}
                      </div>
                    </div>
                    <div :class="isMobile() ? 'row' : ''" v-if="option.phone !== ''">
                      <div class="float-right" :class="isMobile() ? 'col-xs-6 col-sm-6' : 'col-md-4'">
                        <div class="pt-3">
                          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve" class="phone-svg">
                          <path class="st0" d="M0,0h48v48H0V0z"/>
                          <path class="st1" d="M13.2,21.6c2.9,5.7,7.5,10.3,13.2,13.2l4.4-4.4c0.5-0.5,1.3-0.7,2-0.5c2.2,0.7,4.7,1.1,7.1,1.1c1.1,0,2,0.9,2,2
                            v7c0,1.1-0.9,2-2,2C21.2,42,6,26.8,6,8c0-1.1,0.9-2,2-2h7c1.1,0,2,0.9,2,2c0,2.5,0.4,4.9,1.1,7.1c0.2,0.7,0.1,1.5-0.5,2L13.2,21.6z"
                            />
                          </svg>
                          <!-- <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1536 1536" style="fill:#51a7e9;" class="phone-svg">
                          <path class="cls-1" d="M1280,1065c0-7.33-.67-12.67-2-16-2-5.33-14.83-15.17-38.5-29.5s-53.17-30.83-88.5-49.5l-53-29c-3.33-2-9.67-6.33-19-13s-17.67-11.67-25-15-14.33-5-21-5c-12,0-27.67,10.83-47,32.5s-38.33,43.5-57,65.5-33.33,33-44,33c-4.67,0-10.17-1.17-16.5-3.5s-11.5-4.5-15.5-6.5-9.67-5.17-17-9.5-12-7.17-14-8.5c-66-36.67-122.83-78.83-170.5-126.5-47.67-47.67-89.83-104.5-126.5-170.5-1.33-2-4.17-6.67-8.5-14s-7.5-13-9.5-17-4.17-9.17-6.5-15.5-3.5-11.83-3.5-16.5c0-8.67,6.83-19.83,20.5-33.5s28.67-26.5,45-38.5,31.33-25.17,45-39.5,20.5-26.5,20.5-36.5c0-6.67-1.67-13.67-5-21s-8.33-15.67-15-25-11-15.67-13-19c-2-4-7-13.5-15-28.5s-16.33-30.17-25-45.5-17.5-31.17-26.5-47.5-17.33-29.83-25-40.5-13.17-16.67-16.5-18-8.67-2-16-2c-32,0-65.67,7.33-101,22-30.67,14-57.33,45.5-80,94.5s-34,92.5-34,130.5c0,10.67,.83,22,2.5,34s3.33,22.17,5,30.5,4.67,19.33,9,33,7.67,23.5,10,29.5,6.5,17,12.5,33,9.67,26,11,30c40,109.33,112.17,216.17,216.5,320.5s211.17,176.5,320.5,216.5c4,1.33,14,5,30,11s27,10.17,33,12.5,15.83,5.67,29.5,10,24.67,7.33,33,9,18.5,3.33,30.5,5,23.33,2.5,34,2.5c38,0,81.5-11.33,130.5-34s80.5-49.33,94.5-80c14.67-35.33,22-69,22-101Zm256-777v960c0,79.33-28.17,147.17-84.5,203.5s-124.17,84.5-203.5,84.5H288c-79.33,0-147.17-28.17-203.5-84.5C28.17,1395.17,0,1327.33,0,1248V288C0,208.67,28.17,140.83,84.5,84.5,140.83,28.17,208.67,0,288,0h960c79.33,0,147.17,28.17,203.5,84.5,56.33,56.33,84.5,124.17,84.5,203.5Z"/>
                          </svg> -->
                          <span class="">{{option.phone}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </form>
          <br>
          <small class="text-danger" v-show="siteCode.invalid">
            {{getError('siteCode') && computeCaption(getError('siteCode'), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
    <div class="col-md-2 col-md-offset-1 pl-0">
      <language-button id="mobile-language"></language-button>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import axios from 'axios'
  import LanguageButton from '../../LanguageButton'
  import swal from 'sweetalert2'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  import {Input} from 'element-ui'
  import {ValidationUtils} from '../../../../../utils/Validation'
  import {PatientInfoUtils} from '../../../../../utils/PatientInfo'
  export default {
    components: {
      LanguageButton,
      [Input.name]: Input
    },
    mixins: [TranslationsUtils, SettingsUtils, ValidationUtils, PatientInfoUtils],
    props: {
      siteCodeCaption: {
        type: String,
        default: 'Office Location Code'
      }
    },
    data () {
      return {
        show: true,
        options: [],
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        validateTransaction: true,
        fields_en: {
          office_location_code: 'Office Location Code'
        },
        model: {
          siteCode: null,
          transaction_id: null
        },
        modelValidations: {
          siteCode: {
            min: 2,
            required: true
          }
        }
      }
    },
    async mounted () {
      if (this.$route.query.transaction_id) {
        this.model.transaction_id = this.$route.query.transaction_id
        this.checkTransactionId()
      }
      if (this.$route.query.site_code) {
        this.model.siteCode = this.$route.query.site_code
        this.validate(true)
        this.$emit('disabledSubmitButton', true)
      }
      this.$store.state.personIdentifierSection = {
        med_social_security_number: '',
        med_driver_license_number: ''
      }
    },
    methods: {
      getSiteCodeSuggestions (ip) {
        axios({
          url: process.env.SERVER_URI + '/getSuggestions',
          method: 'post',
          data: {ip: ip}
        })
        .then((response) => {
          this.options = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      openGoogleMap (lat, long) {
        const urlSuffix = lat + ',' + long
        window.open('https://www.google.com/maps/search/?api=1&query=' + urlSuffix, '_blank')
      },
      selectOption (option) {
        this.options.forEach(option => { option.selected = false })
        option.selected = true
        this.model.siteCode = option.sitecode
      },
      checkTransactionId () {
        axios.get(process.env.SERVER_URI + '/validate/transation/id/' + this.$route.query.site_code + '/' + this.model.transaction_id)
        .then((response) => {
          this.$store.state.medicalData.first_name = response.data.first_name
          this.$store.state.medicalData.last_name = response.data.last_name
          this.$store.state.medicalData.address = response.data.address
          this.$store.state.medicalData.address2 = response.data.address2
          this.$store.state.medicalData.email = response.data.email
          this.$store.state.medicalData.phone = response.data.phone
        }).catch((error) => {
          if (error.response.status === 429) {
            swal('Error!', 'It looks like you already registered! Please check your email for the confirmation number or try again later', 'error')
            .then(function (result) {
              window.location.reload()
            })
            .catch(swal.noop)
            this.validateTransaction = false
            this.redirect()
          }
        })
      },
      redirect () {
        const body = document.querySelector('body')
        const self = this
        body.onclick = function () {
          self.$router.push({ path: '/' })
          window.location.reload()
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      jumpToTheNextPage () {
        this.$emit('jumpToTheNextPage')
      },
      validate (nextPage) {
        if (this.model.siteCode && this.model.siteCode.length >= 2) {
          return new Promise((resolve, reject) => {
            this.$store.state.invalidSiteCode = false
            this.model.validatedSiteCode = null
            axios.get(process.env.SERVER_URI + '/validate/site/' + this.model.siteCode).then(async (response) => {
              if (response.data === false) {
                this.$emit('disabledSubmitButton', false)
                this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code!'})
                let field = this.$validator._resolveField('siteCode')
                field.setFlags({invalid: true})
                document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
                this.$store.state.invalidSiteCode = true
                this.validatedSectionClass = 'invalid-section-class'
                this.generalClass = 'general-invalid-section'
                reject(new Error('Invalid site code!!'))
              } else {
                this.$store.state.site = response.data
                this.$store.state.sitecode = this.model.siteCode
                if (response.data['logo']) {
                  this.$store.state.logo = response.data['logo']
                }
                if (response.data['required_dl_or_ssn'] === true || response.data['required_dl_or_ssn'] === false) {
                  this.$store.state.dl_or_ssn_required_by_client = response.data['required_dl_or_ssn']
                }
                if (response.data['allow_dl_or_ssn'] === true || response.data['allow_dl_or_ssn'] === false) {
                  this.$store.state.allow_dl_or_ssn = response.data['allow_dl_or_ssn']
                }
                if (response.data['required_uninsured_ssn'] === true || response.data['required_uninsured_ssn'] === false) {
                  this.$store.state.required_uninsured_ssn = response.data['required_uninsured_ssn']
                }
                if (response.data['required_insurance_ssn'] === true || response.data['required_insurance_ssn'] === false) {
                  this.$store.state.required_insurance_ssn = response.data['required_insurance_ssn']
                }
                if (response.data['redirect_registration_url']) {
                  this.$store.state.redirect_registration_url = response.data['redirect_registration_url']
                }
                if (response.data['redirect_payment_url']) {
                  this.$store.state.redirect_payment_url = response.data['redirect_payment_url']
                }
                if (response.data['restrict_email_to_domain']) {
                  this.$store.state.restrict_email_to_domain = response.data['restrict_email_to_domain']
                }

                this.overwriteGraphSettings(response.data)
                // process.env.NODE_ENV = 'testing'
                let one = process.env.SERVER_URI + '/requirements/' + this.model.siteCode
                let two = process.env.SERVER_URI + '/questions/' + this.model.siteCode
                let three = process.env.SERVER_URI + '/insurance/' + this.model.siteCode
                let four = process.env.SERVER_URI + '/ethnicity/' + this.model.siteCode
                let five = process.env.SERVER_URI + '/race/' + this.model.siteCode
                let six = process.env.SERVER_URI + '/gender/' + this.model.siteCode
                let seven = process.env.SERVER_URI + '/allows_client_bill/' + this.model.siteCode
                let eight = process.env.SERVER_URI + '/calculations/' + this.model.siteCode

                const requestOne = axios.get(one)
                const requestTwo = axios.get(two)
                const requestThree = axios.get(three)
                const requestFour = axios.get(four)
                const requestFive = axios.get(five)
                const requestSix = axios.get(six)
                let requestSeven = false
                if (this.allow_client_bill) {
                  requestSeven = axios.get(seven)
                }
                const requestEight = axios.get(eight)
                this.$store.state.questions = []
                await axios.all([requestOne, requestTwo, requestThree, requestFour, requestFive, requestSix, requestSeven, requestEight])
                    .then(axios.spread((...responses) => {
                      this.$emit('disabledSubmitButton', false)
                      if (responses[1].data) {
                        for (let key in responses[1].data.data.questions) {
                          if (parseInt(key) !== responses[1].data.data.questions.length) {
                            responses[1].data.data.questions[key].multiple = []
                            responses[1].data.data.questions[key].multiple_ids = []
                            this.$store.state.questions.push(responses[1].data.data.questions[key])
                          }
                        }
                      }
                      this.$store.state.requirements = {...this.$store.state.requirements, ...responses[0].data}
                      let checkInsurance = !!this.$store.state.site.bills_array.find(bill => bill.type === 'insurance')
                      if (checkInsurance) {
                        if (this.$store.state.requirements.gender) {
                          this.$store.state.requirements.gender.required_portal = '1'
                        } else {
                          this.$store.state.requirements.gender = []
                          this.$store.state.requirements.gender.required_portal = '1'
                        }
                        if (this.$store.state.requirements.address) {
                          this.$store.state.requirements.address.required_portal = '1'
                        } else {
                          this.$store.state.requirements.address = []
                          this.$store.state.requirements.address.required_portal = '1'
                        }
                      }
                      this.$store.state.configs.ALLOW_DRIVER_LICENSE = this.$store.state.requirements.driver_license_image && this.$store.state.requirements.driver_license_image !== ''
                      this.$store.state.configs.REQUIRED_DRIVER_LICENSE = this.checkRequirement('driver_license_image')
                      this.$store.state.configs.ALLOW_INSURANCE_CARD = this.$store.state.requirements.insurance_card_image && this.$store.state.requirements.insurance_card_image !== ''
                      this.$store.state.configs.REQUIRED_INSURANCE_CARD = this.checkRequirement('insurance_card_image')
                      this.$store.state.insurance = responses[2].data
                      this.$store.state.ethnicity = responses[3].data
                      this.$store.state.race = responses[4].data
                      this.$store.state.gender = responses[5].data
                      this.$store.state.allows_client_bill = responses[6].data
                      this.$store.state.calculations = responses[7].data
                      this.$store.state.allCallsDone = true
                      if ((this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && this.$store.state.insuranceType === 'cash') || this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
                        this.$store.state.paymentProcess = true
                      }
                      if (this.$store.state.site.schedule.data.length && this.$store.state.configs.ALLOW_SCHEDULES) {
                        this.$store.state.allowSchedules = true
                      } else {
                        this.$store.state.allowSchedules = false
                      }
                    })).catch(errors => {
                      console.log('Error' + errors)
                    })
                if (nextPage && this.validateTransaction && this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false) {
                  this.$emit('disabledSubmitButton', false)
                  this.jumpToTheNextPage()
                }
              }
              resolve(true)
            }).catch(() => {
              this.$store.state.invalidSiteCode = true
              this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code or server issues!'})
              let field = this.$validator._resolveField('siteCode')
              field.setFlags({invalid: true})
              document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
              reject(new Error('Invalid site code!!'))
            })
          })
        } else {
          this.$validator.errors.add({field: 'siteCode', msg: 'Office Location Code is required!'})
          let field = this.$validator._resolveField('siteCode')
          field.setFlags({invalid: true})
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          this.validatedSectionClass = 'invalid-section-class'
          this.generalClass = 'general-invalid-section'
          return false
        }
      }
    },
    computed: {
      verbiage () {
        return this.$store.state.configs.OFFICE_LOCATION_VERBIAGE
      },
      ...mapFields(['siteCode'])
    },
    async beforeMount () {
      let info = await this.getPatientInfo()
      if (info.ip) {
        this.getSiteCodeSuggestions(info.ip)
      }
    },
    watch: {
      'model.siteCode': {
        handler: function (before, after) {
          if (this.modelValidations.siteCode.required) {
            if (this.model.siteCode.length > this.modelValidations.siteCode.min - 1 && /\S/.test(this.model.siteCode)) {
              this.validatedSectionClass = 'validated-section-class'
              this.generalClass = 'general-inactive-section'
            } else {
              this.validatedSectionClass = 'invalid-section-class'
              this.generalClass = 'general-invalid-section'
            }
          } else {
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          }
          if (before === '') {
            this.options.forEach(option => { option.selected = false })
          }
          if (this.model.siteCode.length > 2) {
            this.show = false
          } else {
            this.show = true
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

  #siteCode{
    text-transform: uppercase;
  }

  >>> .language{
    margin: 0px !important;
    margin-top: 10px !important;
  }

  .pb-5 {
    padding-bottom: 5px;
  }

  .general-inactive-section:focus-within {
    border-left-color: $primary-color !important;
  }

  .selected {
    border: 1px solid $primary-color;
    border-radius: 3px;
  }

  .float-right {
    text-align: right;
    padding-right: 35px;
  }

  .float-left {
    text-align: left;
    padding-left: 35px;
  }

  .distance {
    text-color: $primary-color;
    border: 1px solid $primary-color;
    border-radius: 5px;
    padding: 0px 4px 1px 4px;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: $primary-color;
  }

  .pt-3{
    padding-top: 3px;
  }

  .pt-7{
    padding-top: 7px;
  }

  .fs-17 {
    font-size: 17px !important;
  }

  .p-10 {
    padding-top: 8px;
    padding-bottom: 1px;
    padding-right: 3px;
    padding-left: 3px;
  }

  .bg-color {
    background-color: white;
  }

  .rounded {
    border: 1px solid $default-grey;
    border-radius: 3px;
  }

  .map-svg {
    .st0{fill:#FDDC49;}
    .st1{fill:#56A959;}
    .st2{fill:#5796FF;}
    .st3{fill:#CCCCCC;}
    .st4{fill:#F2F2F2;}
    .st5{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}
    .st6{opacity:0.1;enable-background:new    ;}
    .st7{fill:#E53935;}
    .st8{fill:#B71C1C;}
    .st9{fill:url(#SVGID_1_);}
    width: 40px;
    height: 40px;
  }

  .map-svg:hover {
    cursor: pointer;
  }

  .phone-svg {
    .st0{fill:none;}
    .st1{fill:#51A7E9;}
    width: 20px;
    height: 20px;
  }

  @media (max-width: 992px){
    #mobile-language{
      display: none;
    }
  }

  .pl-0{
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/SiteSelectionStep.vue